module.exports = __webpack_public_path__ + "img/1646_paint.424bebd4.png";